import { useRef } from 'react';

import { useLegalClientLegalHeadFirstHeadSaveIdentityDocument } from 'api/requests';
import { FileUpload, useFilesUpload, useServerErrorNotify } from 'hooks';

import { IdentityDocumentFormType } from '../forms/identityDocumentForm';

import { useOnboardingContext } from './useOnboardingContext';

export const useIdentityDocument = () => {
  const { saveIdentityDocument, error, loading } =
    useLegalClientLegalHeadFirstHeadSaveIdentityDocument();

  const { goToBack, goToNext, data } = useOnboardingContext();

  const initialValues: IdentityDocumentFormType = useRef({
    fileIds:
      data.firstHead.identityDocument?.files.map((file) => file.id) || [],
  }).current;

  const filesUpload: FileUpload[] | undefined =
    data.firstHead.identityDocument?.files?.map(
      (v) =>
        new FileUpload({ name: v.name, size: v.size }, undefined, false, v.id)
    );

  const {
    files,
    isLoadingFile: submitDisabled,
    onRemoveFile,
    onAddFiles,
  } = useFilesUpload(filesUpload);

  const onSubmit = async (values: IdentityDocumentFormType) => {
    const res = await saveIdentityDocument(
      data.legalClient.id,
      data.legalHeadId,
      data.firstHead!.id,
      values.fileIds
    );
    if (res) {
      goToNext();
    }
  };

  useServerErrorNotify(error);

  return {
    submitLoading: loading,
    initialValues,
    submitDisabled,
    files,
    onSubmit,
    goToBack,
    onAddFiles,
    onRemoveFile,
  };
};
